define('SuiteCommerce.ItemBadges.Model', [
  'Backbone.CachedModel'
], function ItemBadgesModel(
  CachedModel
) {
  'use strict';

  return CachedModel.extend({

  });
});
